import React from 'react';
import PropTypes from 'prop-types';

import useInput from '../../utils/common/customHook';

import {
  TITLE_BUTTON_LOGIN,
  TITLE_BUTTON_LOGIN_EN,
  TITLE_EMAIL,
  TITLE_EMAIL_EN,
  TITLE_PASSWORD,
  TITLE_PASSWORD_EN,
} from '../../utils/common/constant';
import DivInputAuthentication from '../styled/div/DivInputAuthentication';
import { InputAuthentication, LabelAuthentication } from '../styled';

const LoginInput = ({ login }) => {
  const [email, onEmailChange] = useInput('');
  const [password, onPasswordChange] = useInput('');
  const locale = 'en';

  function onSubmitHandlerLogin() {
    return login({
      email,
      password,
    });
  }

  return (
    <DivInputAuthentication>
      <LabelAuthentication htmlFor="email">{locale === 'id' ? TITLE_EMAIL : TITLE_EMAIL_EN}</LabelAuthentication>
      <InputAuthentication type="email" id="email" placeholder="Email" value={email} onChange={onEmailChange} />

      <LabelAuthentication htmlFor="password">{locale === 'id' ? TITLE_PASSWORD : TITLE_PASSWORD_EN}</LabelAuthentication>
      <InputAuthentication type="password" id="password" placeholder="Password" value={password} onChange={onPasswordChange} />

      <button type="button" className="button-login" aria-label="login" onClick={onSubmitHandlerLogin}>{locale === 'id' ? TITLE_BUTTON_LOGIN : TITLE_BUTTON_LOGIN_EN}</button>
    </DivInputAuthentication>
  );
};

LoginInput.propTypes = {
  login: PropTypes.func.isRequired,
};

export default LoginInput;
